import { createAction } from '@reduxjs/toolkit';
export const FETCH_MESSAGE_SESSION = 'FETCH_MESSAGE_SESSION';
export const fetchMessageSessionAction = createAction(FETCH_MESSAGE_SESSION);